// extracted by mini-css-extract-plugin
export default {"page-title":"n2vdcNNZPn46PeYu2hsk","page-p":"sLbDAf9EZxIxqvbgTHdL","root":"ZLequpXJzPOoPWXNTRE1","icon":"E3TQLqDnIG6aRopFsNRB","removeButton":"bDOee1pq_xvLGeJEHGyw"};